import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import apiService from '../../services/api';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';
import './Repair.css';

const Repair = ({ activeTab: propActiveTab }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  useEffect(() => {
    if (!propActiveTab) return;
    const map = {
      'repair': 'dashboard',
      'job_sheets': 'job_sheets',
      'add_job_sheet': 'add_job_sheet',
      'list_invoices': 'list_invoices',
      'add_invoice': 'add_invoice',
      'brands': 'brands',
      'repair_settings': 'settings',
    };
    const mapped = map[propActiveTab] || 'dashboard';
    setActiveTab(mapped);
  }, [propActiveTab]);

  const tabs = [
    { id: 'dashboard', label: 'Repair', icon: 'fa-wrench' },
    { id: 'job_sheets', label: 'Job Sheets', icon: 'fa-clipboard-list' },
    { id: 'add_job_sheet', label: 'Add Job sheet', icon: 'fa-plus' },
    { id: 'list_invoices', label: 'List Invoices', icon: 'fa-file-invoice' },
    { id: 'add_invoice', label: 'Add Invoice', icon: 'fa-plus-circle' },
    { id: 'brands', label: 'Brands', icon: 'fa-tags' },
    { id: 'settings', label: 'Settings', icon: 'fa-cog' },
  ];

  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [brands, setBrands] = useState([]);
  const [devices, setDevices] = useState([]);
  const [deviceModels, setDeviceModels] = useState([]);
  const [repairStatuses, setRepairStatuses] = useState([]);
  const [dashboardData, setDashboardData] = useState({ job_sheets_by_status: [], job_sheets_by_service_staff: [], trending_brands: {}, trending_devices: {}, trending_device_models: {} });
  const [jobSheets, setJobSheets] = useState([]);
  const [jobSheetFilterStatus, setJobSheetFilterStatus] = useState('pending');
  const [jobSheetSearch, setJobSheetSearch] = useState('');
  const [repairs, setRepairs] = useState([]);
  const [repairFilterStatus, setRepairFilterStatus] = useState('pending');
  const [repairSearch, setRepairSearch] = useState('');
  const [repairSettings, setRepairSettings] = useState({});
  const [showBrandModal, setShowBrandModal] = useState(false);
  const [brandForm, setBrandForm] = useState({ name: '', description: '', use_for_repair: false });
  const [settingsSubTab, setSettingsSubTab] = useState('status');
  const [settingsSearch, setSettingsSearch] = useState('');

  const [jobSheetForm, setJobSheetForm] = useState({ location_id: '', contact_id: '', service_type: 'Carry in', brand_id: '', device_id: '', device_model_id: '', serial_no: '', security_pwd: '', product_configuration: '', problem_reported_by_customer: '', service_staff: '', estimated_cost: '', status_id: '', delivery_date: '', custom_field_1: '', custom_field_2: '', custom_field_3: '', custom_field_4: '', custom_field_5: '' });
  const [viewJobSheet, setViewJobSheet] = useState(null);
  const [showViewJobSheetModal, setShowViewJobSheetModal] = useState(false);
  const [viewInvoice, setViewInvoice] = useState(null);
  const [showViewInvoiceModal, setShowViewInvoiceModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusForm, setStatusForm] = useState({ name: '', color: '#3b82f6', sort_order: 0, is_completed_status: false });
  const [editStatusId, setEditStatusId] = useState(null);
  const [editBrandId, setEditBrandId] = useState(null);

  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [customerForm, setCustomerForm] = useState({ name: '', mobile: '', email: '' });

  const [showDeviceModal, setShowDeviceModal] = useState(false);
  const [deviceForm, setDeviceForm] = useState({ name: '', short_code: '', description: '' });

  const [showDeviceModelModal, setShowDeviceModelModal] = useState(false);
  const [deviceModelForm, setDeviceModelForm] = useState({ name: '', brand_id: '', device_id: '' });

  const [repairSettingsForm, setRepairSettingsForm] = useState({
    default_status: '',
    job_sheet_prefix: '',
    default_repair_checklist: '',
    product_configuration: '',
    problem_reported_by_customer: '',
    product_condition: '',
    repair_tc_condition: '',
    job_sheet_custom_field_1: '',
    job_sheet_custom_field_2: '',
    job_sheet_custom_field_3: '',
    job_sheet_custom_field_4: '',
    job_sheet_custom_field_5: '',
  });

  const [pdfSettingsForm, setPdfSettingsForm] = useState({
    show_customer: 1,
    customer_label: 'Customer',
    show_client_id: 1,
    client_id_label: 'Client ID',
    client_tax_label: 'Tax Label',
    label_width: 75,
    label_height: 50,
    show_customer_name_in_label: 1,
    show_customer_address_in_label: 1,
    show_customer_phone_in_label: 1,
    show_customer_alt_phone_in_label: 0,
    show_customer_email_in_label: 0,
    show_sales_person_in_label: 1,
    show_barcode_in_label: 1,
    show_status_in_label: 1,
    show_due_date_in_label: 1,
    show_technician_in_label: 1,
    show_problem_in_label: 1,
    show_job_sheet_number: 1,
    show_sr_no_in_label: 1,
    show_brand_in_label: 1,
    show_location_in_label: 1,
    show_password_in_label: 1,
  });

  const normalizeData = (data) => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === 'object') {
      return Object.entries(data).map(([id, item]) => {
        if (item && typeof item === 'object') return { id, ...item };
        return { id, name: String(item) };
      });
    }
    return [];
  };

  useEffect(() => { fetchLocations(); fetchCustomers(); fetchRepairBrands(); fetchRepairDevices(); fetchRepairDeviceModels(); fetchRepairStatusesList(); }, []);
  useEffect(() => {
    if (activeTab === 'dashboard') fetchDashboard();
    if (activeTab === 'job_sheets') fetchJobSheets();
    if (activeTab === 'add_job_sheet') {
      fetchCustomers();
      fetchRepairBrands();
      fetchRepairDevices();
      fetchRepairDeviceModels();
      fetchRepairStatusesList();
    }
    if (activeTab === 'list_invoices') fetchRepairs();
    if (activeTab === 'brands') fetchRepairBrands();
    if (activeTab === 'settings') fetchSettings();
  }, [activeTab]);

  const fetchLocations = async () => { try { const r = await apiService.getLocations(); setLocations(normalizeData(r?.data || r)); } catch (e) {} };
  const fetchCustomers = async () => { try { const r = await apiService.getContacts({ type: 'customer' }); setCustomers(normalizeData(r?.data || r)); } catch (e) {} };
  const fetchRepairBrands = async () => { try { const r = await apiService.getRepairBrands(); setBrands(normalizeData(r?.data || r)); } catch (e) {} };
  const fetchRepairDevices = async () => { try { const r = await apiService.getRepairDevices(); setDevices(normalizeData(r?.data || r)); } catch (e) {} };
  const fetchRepairDeviceModels = async () => { try { const r = await apiService.getRepairDeviceModels(); setDeviceModels(normalizeData(r?.data || r)); } catch (e) {} };
  const fetchRepairStatusesList = async () => { try { const r = await apiService.getRepairStatuses(); setRepairStatuses(normalizeData(r?.data || r)); } catch (e) {} };
  const fetchDashboard = async () => { setLoading(true); try { const r = await apiService.getRepairDashboard(); setDashboardData(r); } catch (e) {} finally { setLoading(false); } };
  const fetchJobSheets = async () => { setLoading(true); try { const r = await apiService.getRepairJobSheets({ is_completed_status: jobSheetFilterStatus === 'completed' ? 1 : 0 }); setJobSheets(normalizeData(r?.data || r)); } catch (e) {} finally { setLoading(false); } };
  const fetchRepairs = async () => { setLoading(true); try { const r = await apiService.getRepairRepairs({ is_completed_status: repairFilterStatus === 'completed' ? 1 : 0 }); setRepairs(normalizeData(r?.data || r)); } catch (e) {} finally { setLoading(false); } };
  const fetchSettings = async () => {
    setLoading(true);
    try {
      const r = await apiService.getRepairSettings();
      setRepairSettings(r);
      if (r?.repair_settings) setRepairSettingsForm(prev => ({ ...prev, ...r.repair_settings }));
      if (r?.jobsheet_pdf_settings) setPdfSettingsForm(prev => ({ ...prev, ...r.jobsheet_pdf_settings }));
    } catch (e) {} finally { setLoading(false); }
  };

  const handleSavePdfSettings = async () => {
    try {
      setLoading(true);
      const res = await apiService.saveRepairSettings(pdfSettingsForm);
      if (res && res.success !== false) {
        toast.success(res.msg || 'Jobsheet PDF & Label settings saved successfully!');
        fetchSettings();
      } else { toast.error(res?.msg || 'Error saving PDF & Label settings'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleSaveRepairSettingsState = async () => {
    try {
      setLoading(true);
      const res = await apiService.saveRepairSettings(repairSettingsForm);
      if (res && res.success !== false) {
        toast.success(res.msg || 'Repair settings saved successfully!');
        fetchSettings();
      } else { toast.error(res?.msg || 'Error saving repair settings'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleSaveJobSheet = async () => {
    if (!jobSheetForm.serial_no || !jobSheetForm.status_id) { toast.warning('Please fill in required fields (Serial Number and Status)'); return; }
    try {
      setLoading(true);
      const res = await apiService.createRepairJobSheet(jobSheetForm);
      if (res && res.success !== false) {
        toast.success(res.msg || 'Job Sheet created successfully!');
        setJobSheetForm({ location_id: '', contact_id: '', service_type: 'Carry in', brand_id: '', device_id: '', device_model_id: '', serial_no: '', security_pwd: '', product_configuration: '', problem_reported_by_customer: '', service_staff: '', estimated_cost: '', status_id: '', delivery_date: '', custom_field_1: '', custom_field_2: '', custom_field_3: '', custom_field_4: '', custom_field_5: '' });
        setActiveTab('job_sheets'); fetchJobSheets();
      } else { toast.error(res?.msg || 'Error creating Job Sheet'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleDeleteJobSheet = async (id) => {
    if (!window.confirm('Delete Job Sheet?')) return;
    try { const res = await apiService.deleteRepairJobSheet(id); if (res && res.success !== false) { toast.success('Job Sheet deleted successfully'); fetchJobSheets(); } else { toast.error(res?.msg || 'Error deleting Job Sheet'); } } catch (e) { toast.error(e.message); }
  };

  const handleSaveBrand = async () => {
    if (!brandForm.name) { toast.warning('Brand name is required'); return; }
    try {
      setLoading(true);
      const res = editBrandId ? await apiService.updateRepairBrand(editBrandId, brandForm) : await apiService.createRepairBrand(brandForm);
      if (res && res.success !== false) {
        toast.success(res.msg || 'Brand saved successfully!');
        setShowBrandModal(false);
        setBrandForm({ name: '', description: '', use_for_repair: false });
        setEditBrandId(null);
        fetchRepairBrands();
      } else { toast.error(res?.msg || 'Error saving brand'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleEditBrand = (b) => {
    setEditBrandId(b.id);
    setBrandForm({ name: b.name || '', description: b.description || '', use_for_repair: true });
    setShowBrandModal(true);
  };

  const handleDeleteBrand = async (id) => {
    if (!window.confirm('Are you sure you want to delete this brand?')) return;
    try {
      setLoading(true);
      const res = await apiService.deleteRepairBrand(id);
      if (res && res.success !== false) {
        toast.success('Brand deleted successfully');
        fetchRepairBrands();
      } else { toast.error(res?.msg || 'Error deleting brand'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleDeleteDevice = async (id) => {
    if (!window.confirm('Are you sure you want to delete this device?')) return;
    try {
      setLoading(true);
      const res = await apiService.deleteRepairDevice(id);
      if (res && res.success !== false) {
        toast.success('Device deleted successfully');
        fetchRepairDevices();
      } else { toast.error(res?.msg || 'Error deleting device'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleDeleteDeviceModel = async (id) => {
    if (!window.confirm('Are you sure you want to delete this device model?')) return;
    try {
      setLoading(true);
      const res = await apiService.deleteRepairDeviceModel(id);
      if (res && res.success !== false) {
        toast.success('Device model deleted successfully');
        fetchRepairDeviceModels();
      } else { toast.error(res?.msg || 'Error deleting device model'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleSaveStatus = async () => {
    if (!statusForm.name) { toast.warning('Status name is required'); return; }
    try {
      setLoading(true);
      const res = editStatusId ? await apiService.updateRepairStatus(editStatusId, statusForm) : await apiService.createRepairStatus(statusForm);
      if (res && res.success !== false) { toast.success(res.msg || 'Status saved successfully!'); setShowStatusModal(false); setStatusForm({ name: '', color: '#3b82f6', sort_order: 0, is_completed_status: false }); setEditStatusId(null); fetchSettings(); fetchRepairStatusesList(); } else { toast.error(res?.msg || 'Error saving status'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleDeleteStatus = async (id) => {
    if (!window.confirm('Delete status?')) return;
    try { const res = await apiService.deleteRepairStatus(id); if (res && res.success !== false) { toast.success('Status deleted successfully'); fetchSettings(); fetchRepairStatusesList(); } else { toast.error(res?.msg || 'Error deleting status'); } } catch (e) { toast.error(e.message); }
  };

  const handleSaveCustomer = async () => {
    if (!customerForm.name) { toast.warning('Customer name is required'); return; }
    try {
      setLoading(true);
      const res = await apiService.createRepairCustomer(customerForm);
      if (res && res.success !== false) {
        toast.success('Customer added successfully!');
        setShowCustomerModal(false);
        setCustomerForm({ name: '', mobile: '', email: '' });
        fetchCustomers();
      } else { toast.error(res?.msg || 'Error creating customer'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleSaveDevice = async () => {
    if (!deviceForm.name) { toast.warning('Device name is required'); return; }
    try {
      setLoading(true);
      const res = await apiService.createRepairDevice(deviceForm);
      if (res && res.success !== false) {
        toast.success('Device created successfully!');
        setShowDeviceModal(false);
        setDeviceForm({ name: '', short_code: '', description: '' });
        fetchRepairDevices();
      } else { toast.error(res?.msg || 'Error creating device'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const handleSaveDeviceModel = async () => {
    if (!deviceModelForm.name) { toast.warning('Device model name is required'); return; }
    try {
      setLoading(true);
      const res = await apiService.createRepairDeviceModel(deviceModelForm);
      if (res && res.success !== false) {
        toast.success('Device model created successfully!');
        setShowDeviceModelModal(false);
        setDeviceModelForm({ name: '', brand_id: '', device_id: '' });
        fetchRepairDeviceModels();
      } else { toast.error(res?.msg || 'Error creating device model'); }
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  const fc = (v) => v == null ? '$0.00' : '$' + Number(v).toFixed(2);

  const renderDashboard = () => (
    <div>
      <h2 className="rep-card-title"><i className="fas fa-chart-pie" style={{ color: '#4f46e5' }} /> Repair Dashboard Overview</h2>
      <div className="rep-grid-2">
        <div className="rep-card">
          <h3 className="rep-section-title">Job sheets by status</h3>
          {(dashboardData.job_sheets_by_status || []).length === 0 ? (
            <div className="rep-alert-info">No data found, please add repair!</div>
          ) : (
            <div className="rep-status-grid">
              {(dashboardData.job_sheets_by_status || []).map((s, i) => (
                <div key={i} className="rep-status-card" style={{ borderLeft: `4px solid ${s.color || '#3b82f6'}` }}>
                  <div className="rep-status-label">{s.status_name}</div>
                  <div className="rep-status-count">{s.total_job_sheets || 0}</div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="rep-card">
          <h3 className="rep-section-title">Job sheets by service staff</h3>
          <div className="rep-table-wrap">
            <table className="rep-table">
              <thead><tr><th>#</th><th>Service staff</th><th>Total job sheets</th></tr></thead>
              <tbody>
                {(dashboardData.job_sheets_by_service_staff || []).length === 0 ? (
                  <tr><td colSpan={3} className="rep-empty">No data available</td></tr>
                ) : (dashboardData.job_sheets_by_service_staff || []).map((s, i) => (
                  <tr key={i}><td>{i + 1}</td><td>{s.service_staff || '-'}</td><td>{s.total_job_sheets || 0}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="rep-grid-2">
        <div className="rep-card"><h3 className="rep-section-title">Top Trending Brands</h3><div className="rep-empty"><span>No brand analytics available yet</span></div></div>
        <div className="rep-card"><h3 className="rep-section-title">Top Trending Devices</h3><div className="rep-empty"><span>No device analytics available yet</span></div></div>
      </div>
      <div className="rep-card"><h3 className="rep-section-title">Top Trending Device Models</h3><div className="rep-empty"><span>No model analytics available yet</span></div></div>
    </div>
  );

  const renderJobSheets = () => {
    const filtered = jobSheets.filter(j => !jobSheetSearch || Object.values(j).some(v => String(v).toLowerCase().includes(jobSheetSearch.toLowerCase())));
    return (
      <div>
        <h2 className="rep-card-title"><i className="fas fa-clipboard-list" style={{ color: '#4f46e5' }} /> All Job Sheets</h2>
        <div className="rep-card">
          <div className="rep-filters-bar">
            <button className={`rep-filter-pill ${jobSheetFilterStatus === 'pending' ? 'rep-filter-pill-active' : ''}`} onClick={() => { setJobSheetFilterStatus('pending'); setTimeout(fetchJobSheets, 0); }}><i className="fas fa-clock" style={{ color: '#f59e0b' }} /> Pending <i className="fas fa-info-circle" style={{ color: '#3b82f6' }} /></button>
            <button className={`rep-filter-pill ${jobSheetFilterStatus === 'completed' ? 'rep-filter-pill-active' : ''}`} onClick={() => { setJobSheetFilterStatus('completed'); setTimeout(fetchJobSheets, 0); }}><i className="fas fa-check-circle" style={{ color: '#10b981' }} /> Completed <i className="fas fa-info-circle" style={{ color: '#3b82f6' }} /></button>
          </div>
          <div className="rep-toolbar">
            <div className="rep-toolbar-left">
              <div className="rep-entries-group"><span>Show</span><select><option>All</option><option>10</option><option>25</option><option>50</option><option>100</option></select><span>entries</span></div>
              <button className="rep-btn" onClick={() => exportToCSV(filtered, 'job_sheets')}><i className="fas fa-file-csv" /> Export CSV</button>
              <button className="rep-btn" onClick={() => exportToExcel(filtered, 'job_sheets')}><i className="fas fa-file-excel" /> Export Excel</button>
              <button className="rep-btn" onClick={() => printPage()}><i className="fas fa-print" /> Print</button>
              <button className="rep-btn"><i className="fas fa-columns" /> Column visibility</button>
              <button className="rep-btn" onClick={() => exportToPDF(filtered, 'job_sheets')}><i className="fas fa-file-pdf" /> Export PDF</button>
            </div>
            <div className="rep-toolbar-right">
              <input type="text" className="rep-search" placeholder="Search..." value={jobSheetSearch} onChange={e => setJobSheetSearch(e.target.value)} />
              <button className="rep-btn rep-btn-primary" onClick={() => setActiveTab('add_job_sheet')}><i className="fas fa-plus" /> Add</button>
            </div>
          </div>
          <div className="rep-table-wrap">
            <table className="rep-table">
              <thead><tr><th>Action</th><th>Service type</th><th>Due Date</th><th>Job sheet number</th><th>Invoice No.</th><th>Status</th><th>Customer</th><th>Location</th><th>Brand</th><th>Device</th><th>Device Model</th><th>Serial Number</th><th>Estimated Cost</th><th>Added By</th></tr></thead>
              <tbody>
                {loading ? <tr><td colSpan={14} className="rep-empty">Loading...</td></tr> :
                  filtered.length === 0 ? <tr><td colSpan={14} className="rep-empty">No data available in table</td></tr> :
                  filtered.map(j => (
                    <tr key={j.id}>
                      <td><div className="rep-actions"><button className="rep-btn" title="View" onClick={() => { setViewJobSheet(j); setShowViewJobSheetModal(true); }}><i className="fas fa-eye" /></button><button className="rep-btn" title="Delete" onClick={() => handleDeleteJobSheet(j.id)}><i className="fas fa-trash" /></button></div></td>
                      <td>{j.service_type}</td><td>{j.delivery_date}</td><td>{j.job_sheet_no}</td><td>{j.invoice_no || '-'}</td>
                      <td><span style={{ padding: '0.25rem 0.65rem', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '700', background: j.status_color || '#e2e8f0', color: '#fff' }}>{j.status}</span></td>
                      <td>{j.customer}</td><td>{j.location}</td><td>{j.brand}</td><td>{j.device}</td><td>{j.device_model}</td><td>{j.serial_no}</td><td>{fc(j.estimated_cost)}</td><td>{j.added_by}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="rep-toolbar" style={{ marginTop: '1rem', marginBottom: 0 }}><span>Showing 0 to 0 of {filtered.length} entries</span><div style={{ display: 'flex', gap: '0.35rem' }}><button className="rep-btn">Previous</button><button className="rep-btn">Next</button></div></div>
        </div>
      </div>
    );
  };

  const renderAddJobSheet = () => (
    <div>
      <h2 className="rep-card-title"><i className="fas fa-plus-circle" style={{ color: '#4f46e5' }} /> Create Job Sheet</h2>
      <div className="rep-card">
        <div className="rep-form-row">
          <div className="rep-form-group"><label>Business Location: <span style={{ color: '#ef4444' }}>*</span></label><select className="rep-select" value={jobSheetForm.location_id} onChange={e => setJobSheetForm({ ...jobSheetForm, location_id: e.target.value })}><option value="">Please Select</option>{locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}</select></div>
          <div className="rep-form-group"><label>Customer: <span style={{ color: '#ef4444' }}>*</span></label><div style={{ display: 'flex', gap: '0.5rem' }}><select className="rep-select" style={{ flex: 1 }} value={jobSheetForm.contact_id} onChange={e => setJobSheetForm({ ...jobSheetForm, contact_id: e.target.value })}><option value="">Please Select</option>{customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}</select><button type="button" className="rep-btn rep-btn-blue" style={{ background: '#3b82f6', color: '#ffffff', border: 'none', borderRadius: '8px', minWidth: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => setShowCustomerModal(true)}><i className="fas fa-plus" /></button></div></div>
          <div className="rep-form-group"><label>Service type: <span style={{ color: '#ef4444' }}>*</span></label><div style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem' }}>{['Carry in', 'Pick up', 'On site'].map(t => <label key={t} style={{ fontWeight: 600, fontSize: '0.88rem' }}><input type="radio" name="service_type" checked={jobSheetForm.service_type === t} onChange={() => setJobSheetForm({ ...jobSheetForm, service_type: t })} /> {t}</label>)}</div></div>
        </div>
      </div>
      <div className="rep-card">
        <div className="rep-form-row">
          <div className="rep-form-group"><label>Brand:</label><div style={{ display: 'flex', gap: '0.5rem' }}><select className="rep-select" style={{ flex: 1 }} value={jobSheetForm.brand_id} onChange={e => setJobSheetForm({ ...jobSheetForm, brand_id: e.target.value })}><option value="">Please Select</option>{brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}</select><button type="button" className="rep-btn rep-btn-blue" style={{ background: '#3b82f6', color: '#ffffff', border: 'none', borderRadius: '8px', minWidth: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => setShowBrandModal(true)}><i className="fas fa-plus" /></button></div></div>
          <div className="rep-form-group"><label>Device:</label><div style={{ display: 'flex', gap: '0.5rem' }}><select className="rep-select" style={{ flex: 1 }} value={jobSheetForm.device_id} onChange={e => setJobSheetForm({ ...jobSheetForm, device_id: e.target.value })}><option value="">Please Select</option>{devices.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}</select><button type="button" className="rep-btn rep-btn-blue" style={{ background: '#3b82f6', color: '#ffffff', border: 'none', borderRadius: '8px', minWidth: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => setShowDeviceModal(true)}><i className="fas fa-plus" /></button></div></div>
          <div className="rep-form-group"><label>Device Model:</label><div style={{ display: 'flex', gap: '0.5rem' }}><select className="rep-select" style={{ flex: 1 }} value={jobSheetForm.device_model_id} onChange={e => setJobSheetForm({ ...jobSheetForm, device_model_id: e.target.value })}><option value="">Please Select</option>{deviceModels.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}</select><button type="button" className="rep-btn rep-btn-blue" style={{ background: '#3b82f6', color: '#ffffff', border: 'none', borderRadius: '8px', minWidth: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => setShowDeviceModelModal(true)}><i className="fas fa-plus" /></button></div></div>
        </div>
        <div className="rep-form-row"><div className="rep-form-group" style={{ flex: 1 }}><label>Pre Repair Checklist: <i className="fas fa-info-circle" style={{ color: '#3b82f6' }} /></label><div style={{ fontSize: '0.8rem', color: '#64748b' }}>N/A = Not Applicable</div></div></div>
        <div className="rep-form-row">
          <div className="rep-form-group"><label>Serial Number: <span style={{ color: '#ef4444' }}>*</span></label><input type="text" className="rep-input" placeholder="Serial Number" value={jobSheetForm.serial_no} onChange={e => setJobSheetForm({ ...jobSheetForm, serial_no: e.target.value })} /></div>
          <div className="rep-form-group"><label>Password/Pattern Lock:</label><div style={{ display: 'flex', gap: '0.5rem' }}><input type="text" className="rep-input" placeholder="Password" style={{ flex: 1 }} value={jobSheetForm.security_pwd} onChange={e => setJobSheetForm({ ...jobSheetForm, security_pwd: e.target.value })} /></div></div>
        </div>
        <div className="rep-form-row">
          <div className="rep-form-group"><label>Product Configuration:</label><textarea className="rep-textarea" rows="2" value={jobSheetForm.product_configuration} onChange={e => setJobSheetForm({ ...jobSheetForm, product_configuration: e.target.value })} /></div>
          <div className="rep-form-group"><label>Problem Reported By The Customer:</label><textarea className="rep-textarea" rows="2" value={jobSheetForm.problem_reported_by_customer} onChange={e => setJobSheetForm({ ...jobSheetForm, problem_reported_by_customer: e.target.value })} /></div>
        </div>
        <div className="rep-form-row">
          <div className="rep-form-group"><label>Estimated Cost:</label><input type="number" className="rep-input" placeholder="Estimated Cost" value={jobSheetForm.estimated_cost} onChange={e => setJobSheetForm({ ...jobSheetForm, estimated_cost: e.target.value })} /></div>
          <div className="rep-form-group"><label>Status: <span style={{ color: '#ef4444' }}>*</span></label><select className="rep-select" value={jobSheetForm.status_id} onChange={e => setJobSheetForm({ ...jobSheetForm, status_id: e.target.value })}><option value="">Please Select</option>{repairStatuses.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}</select></div>
          <div className="rep-form-group"><label>Due Date:</label><input type="date" className="rep-input" value={jobSheetForm.delivery_date} onChange={e => setJobSheetForm({ ...jobSheetForm, delivery_date: e.target.value })} /></div>
        </div>
        <div className="rep-form-row">
          <div className="rep-form-group"><label>Custom Field 1:</label><input type="text" className="rep-input" value={jobSheetForm.custom_field_1} onChange={e => setJobSheetForm({ ...jobSheetForm, custom_field_1: e.target.value })} /></div>
          <div className="rep-form-group"><label>Custom Field 2:</label><input type="text" className="rep-input" value={jobSheetForm.custom_field_2} onChange={e => setJobSheetForm({ ...jobSheetForm, custom_field_2: e.target.value })} /></div>
          <div className="rep-form-group"><label>Custom Field 3:</label><input type="text" className="rep-input" value={jobSheetForm.custom_field_3} onChange={e => setJobSheetForm({ ...jobSheetForm, custom_field_3: e.target.value })} /></div>
          <div className="rep-form-group"><label>Custom Field 4:</label><input type="text" className="rep-input" value={jobSheetForm.custom_field_4} onChange={e => setJobSheetForm({ ...jobSheetForm, custom_field_4: e.target.value })} /></div>
        </div>
        <div className="rep-form-actions">
          <button className="rep-btn rep-btn-purple" onClick={handleSaveJobSheet} disabled={loading}><i className="fas fa-save" /> Save Job Sheet</button>
        </div>
      </div>
    </div>
  );

  const renderListInvoices = () => {
    const filtered = repairs.filter(r => !repairSearch || Object.values(r).some(v => String(v).toLowerCase().includes(repairSearch.toLowerCase())));
    return (
      <div>
        <h2 className="rep-card-title"><i className="fas fa-file-invoice" style={{ color: '#4f46e5' }} /> List Invoices</h2>
        <div className="rep-card">
          <div className="rep-filters-bar">
            <button className={`rep-filter-pill ${repairFilterStatus === 'pending' ? 'rep-filter-pill-active' : ''}`} onClick={() => { setRepairFilterStatus('pending'); setTimeout(fetchRepairs, 0); }}><i className="fas fa-clock" style={{ color: '#f59e0b' }} /> Pending <i className="fas fa-info-circle" style={{ color: '#3b82f6' }} /></button>
            <button className={`rep-filter-pill ${repairFilterStatus === 'completed' ? 'rep-filter-pill-active' : ''}`} onClick={() => { setRepairFilterStatus('completed'); setTimeout(fetchRepairs, 0); }}><i className="fas fa-check-circle" style={{ color: '#10b981' }} /> Completed <i className="fas fa-info-circle" style={{ color: '#3b82f6' }} /></button>
          </div>
          <div className="rep-toolbar">
            <div className="rep-toolbar-left">
              <div className="rep-entries-group"><span>Show</span><select><option>All</option><option>10</option><option>25</option><option>50</option><option>100</option></select><span>entries</span></div>
              <button className="rep-btn" onClick={() => exportToCSV(filtered, 'repairs')}><i className="fas fa-file-csv" /> Export CSV</button>
              <button className="rep-btn" onClick={() => exportToExcel(filtered, 'repairs')}><i className="fas fa-file-excel" /> Export Excel</button>
              <button className="rep-btn" onClick={() => printPage()}><i className="fas fa-print" /> Print</button>
              <button className="rep-btn"><i className="fas fa-columns" /> Column visibility</button>
              <button className="rep-btn" onClick={() => exportToPDF(filtered, 'repairs')}><i className="fas fa-file-pdf" /> Export PDF</button>
            </div>
            <div className="rep-toolbar-right">
              <input type="text" className="rep-search" placeholder="Search..." value={repairSearch} onChange={e => setRepairSearch(e.target.value)} />
              <button className="rep-btn rep-btn-primary" onClick={() => setActiveTab('add_invoice')}><i className="fas fa-plus" /> Add</button>
            </div>
          </div>
          <div className="rep-table-wrap">
            <table className="rep-table">
              <thead><tr><th>Action</th><th>Date</th><th>Delivery Date</th><th>Job sheet number</th><th>Invoice No.</th><th>Added By</th><th>Customer name</th><th>Brand</th><th>Device Model</th><th>Serial Number</th><th>Status</th><th>Location</th><th>Repair Warranty</th><th>Payment Status</th></tr></thead>
              <tbody>
                {loading ? <tr><td colSpan={14} className="rep-empty">Loading...</td></tr> :
                  filtered.length === 0 ? <tr><td colSpan={14} className="rep-empty">No data available in table</td></tr> :
                  filtered.map(r => (
                    <tr key={r.id}>
                      <td><div className="rep-actions"><button className="rep-btn" title="View" onClick={() => { setViewInvoice(r); setShowViewInvoiceModal(true); }}><i className="fas fa-eye" /></button></div></td>
                      <td>{r.transaction_date}</td><td>{r.repair_due_date}</td><td>{r.job_sheet_no}</td><td>{r.invoice_no}</td>
                      <td>{r.added_by}</td><td>{r.name}</td><td>{r.brand}</td><td>{r.device_model}</td><td>{r.repair_serial_no}</td>
                      <td><span style={{ padding: '0.25rem 0.65rem', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '700', background: r.status_color || '#e2e8f0', color: '#fff' }}>{r.repair_status}</span></td>
                      <td>{r.business_location}</td><td>{r.warranty_name || '-'}</td><td>{r.payment_status}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="rep-toolbar" style={{ marginTop: '1rem', marginBottom: 0 }}><span>Showing 0 to 0 of {filtered.length} entries</span><div style={{ display: 'flex', gap: '0.35rem' }}><button className="rep-btn">Previous</button><button className="rep-btn">Next</button></div></div>
        </div>
      </div>
    );
  };

  const renderAddInvoice = () => (
    <div>
      <h2 className="rep-card-title"><i className="fas fa-plus-circle" style={{ color: '#4f46e5' }} /> Add Invoice</h2>
      <div className="rep-card rep-empty" style={{ padding: '3rem' }}>
        <p style={{ fontSize: '1rem', fontWeight: 600, color: '#334155', marginBottom: '1.25rem' }}>Add Invoice form - integrate with POS Sell form for repair sub_type</p>
        <button className="rep-btn rep-btn-primary" onClick={() => alert('Open POS Sell with sub_type=repair')}><i className="fas fa-arrow-right" /> Open Sell Form</button>
      </div>
    </div>
  );

  const renderBrands = () => {
    const filteredBrands = brands.filter(b => !settingsSearch || (b.name && b.name.toLowerCase().includes(settingsSearch.toLowerCase())));
    return (
      <div>
        <h2 className="rep-card-title"><i className="fas fa-tags" style={{ color: '#4f46e5' }} /> Repair Brands</h2>
        <div className="rep-card">
          <h3 className="rep-section-title">All Registered Repair Brands</h3>
          <div className="rep-toolbar" style={{ marginBottom: '1rem' }}>
            <div className="rep-toolbar-left">
              <div className="rep-entries-group"><span>Show</span><select><option>All</option><option>10</option><option>25</option><option>50</option><option>100</option></select><span>entries</span></div>
              <button className="rep-btn" onClick={() => exportToCSV(filteredBrands, 'brands')}><i className="fas fa-file-csv" /> Export CSV</button>
              <button className="rep-btn" onClick={() => exportToExcel(filteredBrands, 'brands')}><i className="fas fa-file-excel" /> Export Excel</button>
              <button className="rep-btn" onClick={() => printPage()}><i className="fas fa-print" /> Print</button>
              <button className="rep-btn"><i className="fas fa-columns" /> Column visibility</button>
              <button className="rep-btn" onClick={() => exportToPDF(filteredBrands, 'brands')}><i className="fas fa-file-pdf" /> Export PDF</button>
            </div>
            <div className="rep-toolbar-right">
              <input type="text" className="rep-search" placeholder="Search..." value={settingsSearch} onChange={e => setSettingsSearch(e.target.value)} />
              <button className="rep-btn rep-btn-primary" onClick={() => { setEditBrandId(null); setBrandForm({ name: '', description: '', use_for_repair: true }); setShowBrandModal(true); }}><i className="fas fa-plus" /> Add</button>
            </div>
          </div>
          <div className="rep-table-wrap">
            <table className="rep-table"><thead><tr><th>Brand Name</th><th>Short Description</th><th>Action</th></tr></thead>
              <tbody>
                {filteredBrands.length === 0 ? <tr><td colSpan={3} className="rep-empty">No data available in table</td></tr> :
                  filteredBrands.map(b => (
                    <tr key={b.id}><td>{b.name}</td><td>{b.description || '-'}</td>
                      <td>
                        <div style={{ display: 'flex', gap: '0.35rem' }}>
                          <button className="rep-btn" title="Edit" onClick={() => handleEditBrand(b)}><i className="fas fa-edit" /></button>
                          <button className="rep-btn" title="Delete" onClick={() => handleDeleteBrand(b.id)}><i className="fas fa-trash" /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="rep-toolbar" style={{ marginTop: '1rem', marginBottom: 0 }}><span>Showing 0 to 0 of {filteredBrands.length} entries</span><div style={{ display: 'flex', gap: '0.35rem' }}><button className="rep-btn">Previous</button><button className="rep-btn">Next</button></div></div>
        </div>
      </div>
    );
  };

  const renderSettings = () => {
    const settingsTabs = [
      { id: 'status', label: 'Status', icon: 'fa-check-circle' },
      { id: 'devices', label: 'Devices', icon: 'fa-mobile-alt' },
      { id: 'device_models', label: 'Device Models', icon: 'fa-bolt' },
      { id: 'repair_settings', label: 'Repair Settings', icon: 'fa-cogs' },
      { id: 'jobsheet_pdf', label: 'Jobsheet PDF & Label', icon: 'fa-file-pdf' },
    ];

    const statuses = repairSettings?.repair_statuses || repairStatuses || [];
    const filteredStatuses = statuses.filter(s => !settingsSearch || (s.name && s.name.toLowerCase().includes(settingsSearch.toLowerCase())));

    const filteredDevices = devices.filter(d => !settingsSearch || (d.name && d.name.toLowerCase().includes(settingsSearch.toLowerCase())));
    const filteredModels = deviceModels.filter(m => !settingsSearch || (m.name && m.name.toLowerCase().includes(settingsSearch.toLowerCase())));

    return (
      <div>
        <h2 className="rep-card-title"><i className="fas fa-cog" style={{ color: '#4f46e5' }} /> Repair Settings</h2>
        <div className="rep-card">
          <div className="rep-settings-tabs">
            {settingsTabs.map(t => (
              <button key={t.id} className={`rep-settings-tab ${settingsSubTab === t.id ? 'rep-settings-tab-active' : ''}`} onClick={() => setSettingsSubTab(t.id)}>
                <i className={`fas ${t.icon}`} /> {t.label}
              </button>
            ))}
          </div>

          {/* Sub-tab 1: Status */}
          {settingsSubTab === 'status' && (
            <div>
              <div className="rep-toolbar" style={{ marginBottom: '1rem' }}>
                <div className="rep-toolbar-left">
                  <div className="rep-entries-group"><span>Show</span><select><option>All</option><option>10</option><option>25</option><option>50</option><option>100</option></select><span>entries</span></div>
                  <button className="rep-btn" onClick={() => exportToCSV(filteredStatuses, 'repair_statuses')}><i className="fas fa-file-csv" /> Export CSV</button>
                  <button className="rep-btn" onClick={() => exportToExcel(filteredStatuses, 'repair_statuses')}><i className="fas fa-file-excel" /> Export Excel</button>
                  <button className="rep-btn" onClick={() => printPage()}><i className="fas fa-print" /> Print</button>
                  <button className="rep-btn"><i className="fas fa-columns" /> Column visibility</button>
                  <button className="rep-btn" onClick={() => exportToPDF(filteredStatuses, 'repair_statuses')}><i className="fas fa-file-pdf" /> Export PDF</button>
                </div>
                <div className="rep-toolbar-right">
                  <input type="text" className="rep-search" placeholder="Search..." value={settingsSearch} onChange={e => setSettingsSearch(e.target.value)} />
                  <button className="rep-btn rep-btn-primary" onClick={() => { setEditStatusId(null); setStatusForm({ name: '', color: '#3b82f6', sort_order: 0, is_completed_status: false }); setShowStatusModal(true); }}><i className="fas fa-plus" /> Add</button>
                </div>
              </div>
              <div className="rep-table-wrap">
                <table className="rep-table">
                  <thead><tr><th>Status Name</th><th>Color</th><th>Sort Order</th><th>Action</th></tr></thead>
                  <tbody>
                    {filteredStatuses.length === 0 ? <tr><td colSpan={4} className="rep-empty">No data available in table</td></tr> :
                      filteredStatuses.map(s => (
                        <tr key={s.id}><td>{s.name}</td><td><span style={{ display: 'inline-block', width: '16px', height: '16px', borderRadius: '50%', background: s.color || '#ccc' }} /></td><td>{s.sort_order || 0}</td>
                          <td><div style={{ display: 'flex', gap: '0.35rem' }}>
                            <button className="rep-btn" title="Edit" onClick={() => { setEditStatusId(s.id); setStatusForm({ name: s.name, color: s.color || '#3b82f6', sort_order: s.sort_order || 0, is_completed_status: !!s.is_completed_status }); setShowStatusModal(true); }}><i className="fas fa-edit" /></button>
                            <button className="rep-btn" title="Delete" onClick={() => handleDeleteStatus(s.id)}><i className="fas fa-trash" /></button>
                          </div></td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="rep-toolbar" style={{ marginTop: '1rem', marginBottom: 0 }}><span>Showing 0 to 0 of {filteredStatuses.length} entries</span><div style={{ display: 'flex', gap: '0.35rem' }}><button className="rep-btn">Previous</button><button className="rep-btn">Next</button></div></div>
            </div>
          )}

          {/* Sub-tab 2: Devices */}
          {settingsSubTab === 'devices' && (
            <div>
              <div className="rep-toolbar" style={{ marginBottom: '1rem' }}>
                <div className="rep-toolbar-left">
                  <div className="rep-entries-group"><span>Show</span><select><option>All</option><option>10</option><option>25</option><option>50</option><option>100</option></select><span>entries</span></div>
                  <button className="rep-btn" onClick={() => exportToCSV(filteredDevices, 'devices')}><i className="fas fa-file-csv" /> Export CSV</button>
                  <button className="rep-btn" onClick={() => exportToExcel(filteredDevices, 'devices')}><i className="fas fa-file-excel" /> Export Excel</button>
                  <button className="rep-btn" onClick={() => printPage()}><i className="fas fa-print" /> Print</button>
                </div>
                <div className="rep-toolbar-right">
                  <input type="text" className="rep-search" placeholder="Search..." value={settingsSearch} onChange={e => setSettingsSearch(e.target.value)} />
                  <button className="rep-btn rep-btn-primary" onClick={() => setShowDeviceModal(true)}><i className="fas fa-plus" /> Add Device</button>
                </div>
              </div>
              <div className="rep-table-wrap">
                <table className="rep-table">
                  <thead><tr><th>Device Name</th><th>Short Code</th><th>Description</th><th>Action</th></tr></thead>
                  <tbody>
                    {filteredDevices.length === 0 ? <tr><td colSpan={4} className="rep-empty">No devices found</td></tr> :
                      filteredDevices.map(d => (
                        <tr key={d.id}>
                          <td><strong>{d.name}</strong></td>
                          <td>{d.short_code || '-'}</td>
                          <td>{d.description || '-'}</td>
                          <td>
                            <div style={{ display: 'flex', gap: '0.35rem' }}>
                              <button className="rep-btn" title="Edit"><i className="fas fa-edit" /></button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Sub-tab 3: Device Models */}
          {settingsSubTab === 'device_models' && (
            <div>
              <div className="rep-toolbar" style={{ marginBottom: '1rem' }}>
                <div className="rep-toolbar-left">
                  <div className="rep-entries-group"><span>Show</span><select><option>All</option><option>10</option><option>25</option><option>50</option><option>100</option></select><span>entries</span></div>
                  <button className="rep-btn" onClick={() => exportToCSV(filteredModels, 'device_models')}><i className="fas fa-file-csv" /> Export CSV</button>
                  <button className="rep-btn" onClick={() => exportToExcel(filteredModels, 'device_models')}><i className="fas fa-file-excel" /> Export Excel</button>
                  <button className="rep-btn" onClick={() => printPage()}><i className="fas fa-print" /> Print</button>
                </div>
                <div className="rep-toolbar-right">
                  <input type="text" className="rep-search" placeholder="Search..." value={settingsSearch} onChange={e => setSettingsSearch(e.target.value)} />
                  <button className="rep-btn rep-btn-primary" onClick={() => setShowDeviceModelModal(true)}><i className="fas fa-plus" /> Add Device Model</button>
                </div>
              </div>
              <div className="rep-table-wrap">
                <table className="rep-table">
                  <thead><tr><th>Model Name</th><th>Brand</th><th>Device</th><th>Action</th></tr></thead>
                  <tbody>
                    {filteredModels.length === 0 ? <tr><td colSpan={4} className="rep-empty">No device models found</td></tr> :
                      filteredModels.map(m => (
                        <tr key={m.id}>
                          <td><strong>{m.name}</strong></td>
                          <td>{m.brand_id || '-'}</td>
                          <td>{m.device_id || '-'}</td>
                          <td>
                            <div style={{ display: 'flex', gap: '0.35rem' }}>
                              <button className="rep-btn" title="Edit"><i className="fas fa-edit" /></button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Sub-tab 4: Repair Settings */}
          {settingsSubTab === 'repair_settings' && (
            <div style={{ padding: '0.5rem 0' }}>
              <div className="rep-form-row">
                <div className="rep-form-group">
                  <label>Default Job Sheet Status:</label>
                  <select className="rep-select" value={repairSettingsForm.default_status} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, default_status: e.target.value })}>
                    <option value="">Please Select</option>
                    {repairStatuses.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                  </select>
                </div>
                <div className="rep-form-group">
                  <label>Job Sheet Prefix:</label>
                  <input type="text" className="rep-input" placeholder="e.g. JS-" value={repairSettingsForm.job_sheet_prefix} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, job_sheet_prefix: e.target.value })} />
                </div>
              </div>
              <div className="rep-form-row">
                <div className="rep-form-group">
                  <label>Default Repair Checklist:</label>
                  <textarea className="rep-textarea" rows={3} placeholder="Enter default checklist items separated by commas" value={repairSettingsForm.default_repair_checklist} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, default_repair_checklist: e.target.value })} />
                </div>
                <div className="rep-form-group">
                  <label>Product Configuration:</label>
                  <textarea className="rep-textarea" rows={3} placeholder="Product Configuration details" value={repairSettingsForm.product_configuration} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, product_configuration: e.target.value })} />
                </div>
              </div>
              <div className="rep-form-row">
                <div className="rep-form-group">
                  <label>Problem Reported By Customer:</label>
                  <textarea className="rep-textarea" rows={3} placeholder="Common problem notes" value={repairSettingsForm.problem_reported_by_customer} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, problem_reported_by_customer: e.target.value })} />
                </div>
                <div className="rep-form-group">
                  <label>Condition Of Product:</label>
                  <textarea className="rep-textarea" rows={3} placeholder="Default product condition" value={repairSettingsForm.product_condition} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, product_condition: e.target.value })} />
                </div>
              </div>
              <div className="rep-form-group" style={{ marginBottom: '1.25rem' }}>
                <label>Repair Terms & Conditions:</label>
                <textarea className="rep-textarea" rows={4} placeholder="Enter Repair terms and conditions text..." value={repairSettingsForm.repair_tc_condition} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, repair_tc_condition: e.target.value })} />
              </div>
              <hr style={{ margin: '1.5rem 0', borderColor: '#e2e8f0' }} />
              <h4 style={{ margin: '0 0 1rem', fontSize: '1rem', fontWeight: 700 }}>Job Sheet Custom Fields:</h4>
              <div className="rep-form-row">
                <div className="rep-form-group"><label>Custom Field 1 Label:</label><input type="text" className="rep-input" value={repairSettingsForm.job_sheet_custom_field_1} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, job_sheet_custom_field_1: e.target.value })} /></div>
                <div className="rep-form-group"><label>Custom Field 2 Label:</label><input type="text" className="rep-input" value={repairSettingsForm.job_sheet_custom_field_2} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, job_sheet_custom_field_2: e.target.value })} /></div>
                <div className="rep-form-group"><label>Custom Field 3 Label:</label><input type="text" className="rep-input" value={repairSettingsForm.job_sheet_custom_field_3} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, job_sheet_custom_field_3: e.target.value })} /></div>
                <div className="rep-form-group"><label>Custom Field 4 Label:</label><input type="text" className="rep-input" value={repairSettingsForm.job_sheet_custom_field_4} onChange={e => setRepairSettingsForm({ ...repairSettingsForm, job_sheet_custom_field_4: e.target.value })} /></div>
              </div>
              <div className="rep-form-actions" style={{ justifyContent: 'flex-end', marginTop: '1.5rem' }}>
                <button className="rep-btn rep-btn-primary" onClick={handleSaveRepairSettingsState} disabled={loading}><i className="fas fa-save" /> Save Repair Settings</button>
              </div>
            </div>
          )}

          {/* Sub-tab 5: Jobsheet PDF & Label */}
          {settingsSubTab === 'jobsheet_pdf' && (
            <div style={{ padding: '0.5rem 0' }}>
              <h4 style={{ margin: '0 0 1rem', fontSize: '1.05rem', fontWeight: 700 }}>Fields for Customer Details on PDF:</h4>
              <div className="rep-form-row">
                <div className="rep-form-group" style={{ flex: '0 0 200px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                    <input type="checkbox" checked={!!pdfSettingsForm.show_customer} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_customer: e.target.checked ? 1 : 0 })} /> Show Customer
                  </label>
                </div>
                <div className="rep-form-group">
                  <label>Customer Label:</label>
                  <input type="text" className="rep-input" value={pdfSettingsForm.customer_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, customer_label: e.target.value })} />
                </div>
                <div className="rep-form-group">
                  <label>Client ID Label:</label>
                  <input type="text" className="rep-input" value={pdfSettingsForm.client_id_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, client_id_label: e.target.value })} />
                </div>
              </div>
              <hr style={{ margin: '1.5rem 0', borderColor: '#e2e8f0' }} />
              <h4 style={{ margin: '0 0 1rem', fontSize: '1.05rem', fontWeight: 700 }}>Job Sheet Label Dimensions & Options:</h4>
              <div className="rep-form-row">
                <div className="rep-form-group">
                  <label>Label Width (MM):</label>
                  <input type="number" className="rep-input" value={pdfSettingsForm.label_width} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, label_width: e.target.value })} />
                </div>
                <div className="rep-form-group">
                  <label>Label Height (MM):</label>
                  <input type="number" className="rep-input" value={pdfSettingsForm.label_height} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, label_height: e.target.value })} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.25rem', marginTop: '1rem' }}>
                <div>
                  <h5 style={{ fontWeight: 700, margin: '0 0 0.5rem' }}>Customer Information:</h5>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_customer_name_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_customer_name_in_label: e.target.checked ? 1 : 0 })} /> Customer Name</label>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_customer_address_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_customer_address_in_label: e.target.checked ? 1 : 0 })} /> Customer Address</label>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_customer_phone_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_customer_phone_in_label: e.target.checked ? 1 : 0 })} /> Customer Phone</label>
                </div>
                <div>
                  <h5 style={{ fontWeight: 700, margin: '0 0 0.5rem' }}>Label Details:</h5>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_sales_person_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_sales_person_in_label: e.target.checked ? 1 : 0 })} /> Sales Person</label>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_barcode_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_barcode_in_label: e.target.checked ? 1 : 0 })} /> Barcode</label>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_status_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_status_in_label: e.target.checked ? 1 : 0 })} /> Status</label>
                </div>
                <div>
                  <h5 style={{ fontWeight: 700, margin: '0 0 0.5rem' }}>Label Information:</h5>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_technician_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_technician_in_label: e.target.checked ? 1 : 0 })} /> Technician</label>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_problem_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_problem_in_label: e.target.checked ? 1 : 0 })} /> Problem</label>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_job_sheet_number} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_job_sheet_number: e.target.checked ? 1 : 0 })} /> Job Sheet Number</label>
                </div>
                <div>
                  <h5 style={{ fontWeight: 700, margin: '0 0 0.5rem' }}>Device Info:</h5>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_sr_no_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_sr_no_in_label: e.target.checked ? 1 : 0 })} /> IMEI / Serial Number</label>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_brand_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_brand_in_label: e.target.checked ? 1 : 0 })} /> Brand & Model</label>
                  <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.88rem' }}><input type="checkbox" checked={!!pdfSettingsForm.show_location_in_label} onChange={e => setPdfSettingsForm({ ...pdfSettingsForm, show_location_in_label: e.target.checked ? 1 : 0 })} /> Location</label>
                </div>
              </div>
              <div className="rep-form-actions" style={{ justifyContent: 'flex-end', marginTop: '1.5rem' }}>
                <button className="rep-btn rep-btn-primary" onClick={handleSavePdfSettings} disabled={loading}><i className="fas fa-save" /> Save PDF & Label Settings</button>
              </div>
            </div>
          )}
        </div>

        {showStatusModal && (
          <div className="rep-modal-overlay" onClick={() => setShowStatusModal(false)}>
            <div className="rep-modal" onClick={e => e.stopPropagation()}>
              <div className="rep-modal-header">
                <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}>{editStatusId ? 'Edit Status' : 'Add Status'}</h3>
                <button className="rep-modal-close" onClick={() => setShowStatusModal(false)}>&times;</button>
              </div>
              <div className="rep-form-group"><label>Status Name: <span style={{ color: '#ef4444' }}>*</span></label><input type="text" className="rep-input" placeholder="Status Name" value={statusForm.name} onChange={e => setStatusForm({ ...statusForm, name: e.target.value })} /></div>
              <div className="rep-form-group" style={{ marginTop: '1rem' }}><label>Color:</label><input type="color" className="rep-input" style={{ height: '40px', padding: '2px' }} value={statusForm.color} onChange={e => setStatusForm({ ...statusForm, color: e.target.value })} /></div>
              <div className="rep-form-group" style={{ marginTop: '1rem' }}><label>Sort Order:</label><input type="number" className="rep-input" placeholder="0" value={statusForm.sort_order} onChange={e => setStatusForm({ ...statusForm, sort_order: e.target.value })} /></div>
              <div style={{ marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}><input type="checkbox" id="is_completed_status" checked={statusForm.is_completed_status} onChange={e => setStatusForm({ ...statusForm, is_completed_status: e.target.checked })} /><label htmlFor="is_completed_status" style={{ fontWeight: 600, fontSize: '0.88rem' }}>Is Completed Status?</label></div>
              <div className="rep-modal-footer">
                <button className="rep-btn" onClick={() => setShowStatusModal(false)}>Cancel</button>
                <button className="rep-btn rep-btn-primary" onClick={handleSaveStatus} disabled={loading}><i className="fas fa-save" /> Save Status</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="rep-page">
      {/* Page Header Banner */}
      <div className="rep-page-header">
        <div className="rep-page-header-title-wrap">
          <div className="rep-page-icon">
            <i className="fas fa-wrench" />
          </div>
          <div>
            <h1>Repair Management</h1>
            <div className="rep-page-header-subtitle">Track job sheets, device repairs, customer invoices, brands, and technician workflows</div>
          </div>
        </div>
      </div>

      {/* Top Stats Overview Grid */}
      <div className="rep-stats-grid">
        <div className="rep-stat-card">
          <div className="rep-stat-icon-wrap" style={{ background: 'rgba(79, 70, 229, 0.1)', color: '#4f46e5' }}>
            <i className="fas fa-clipboard-list" />
          </div>
          <div className="rep-stat-info">
            <div className="rep-stat-label">Job Sheets</div>
            <div className="rep-stat-value">{jobSheets.length || 0}</div>
            <div className="rep-stat-subtext">Total active job sheets</div>
          </div>
        </div>

        <div className="rep-stat-card">
          <div className="rep-stat-icon-wrap" style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b' }}>
            <i className="fas fa-clock" />
          </div>
          <div className="rep-stat-info">
            <div className="rep-stat-label">Pending Repairs</div>
            <div className="rep-stat-value">{jobSheets.filter(j => j.status !== 'completed').length || 0}</div>
            <div className="rep-stat-subtext">Repairs in progress</div>
          </div>
        </div>

        <div className="rep-stat-card">
          <div className="rep-stat-icon-wrap" style={{ background: 'rgba(16, 185, 129, 0.1)', color: '#10b981' }}>
            <i className="fas fa-file-invoice-dollar" />
          </div>
          <div className="rep-stat-info">
            <div className="rep-stat-label">Invoices</div>
            <div className="rep-stat-value">{repairs.length || 0}</div>
            <div className="rep-stat-subtext">Generated repair invoices</div>
          </div>
        </div>

        <div className="rep-stat-card">
          <div className="rep-stat-icon-wrap" style={{ background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6' }}>
            <i className="fas fa-tags" />
          </div>
          <div className="rep-stat-info">
            <div className="rep-stat-label">Brands</div>
            <div className="rep-stat-value">{brands.length || 0}</div>
            <div className="rep-stat-subtext">Repair brands registered</div>
          </div>
        </div>
      </div>

      {/* Pill Tabs Navigation */}
      <div className="rep-tabs-nav">
        {tabs.map(t => (
          <button key={t.id} className={`rep-tab-btn ${activeTab === t.id ? 'active' : ''}`} onClick={() => setActiveTab(t.id)}>
            <i className={`fas ${t.icon}`} /> {t.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="rep-content">
        {activeTab === 'dashboard' && renderDashboard()}
        {activeTab === 'job_sheets' && renderJobSheets()}
        {activeTab === 'add_job_sheet' && renderAddJobSheet()}
        {activeTab === 'list_invoices' && renderListInvoices()}
        {activeTab === 'add_invoice' && renderAddInvoice()}
        {activeTab === 'brands' && renderBrands()}
        {activeTab === 'settings' && renderSettings()}
      </div>

      {/* View Job Sheet Modal */}
      {showViewJobSheetModal && viewJobSheet && (
        <div className="rep-modal-overlay" onClick={() => setShowViewJobSheetModal(false)}>
          <div className="rep-modal" style={{ maxWidth: '650px' }} onClick={e => e.stopPropagation()}>
            <div className="rep-modal-header">
              <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}><i className="fas fa-clipboard-list" /> Job Sheet: {viewJobSheet.job_sheet_no}</h3>
              <button className="rep-modal-close" onClick={() => setShowViewJobSheetModal(false)}>&times;</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.85rem', fontSize: '0.88rem' }}>
              <div><strong>Service Type:</strong> {viewJobSheet.service_type || '-'}</div>
              <div><strong>Job Sheet No:</strong> {viewJobSheet.job_sheet_no || '-'}</div>
              <div><strong>Customer:</strong> {viewJobSheet.customer || '-'}</div>
              <div><strong>Brand:</strong> {viewJobSheet.brand || '-'}</div>
              <div><strong>Device:</strong> {viewJobSheet.device || '-'}</div>
              <div><strong>Device Model:</strong> {viewJobSheet.device_model || '-'}</div>
              <div><strong>Serial Number:</strong> {viewJobSheet.serial_no || '-'}</div>
              <div><strong>Estimated Cost:</strong> {fc(viewJobSheet.estimated_cost)}</div>
              <div><strong>Status:</strong> <span style={{ padding: '0.2rem 0.5rem', borderRadius: '10px', background: viewJobSheet.status_color || '#e2e8f0', color: '#fff', fontSize: '0.75rem', fontWeight: 700 }}>{viewJobSheet.status}</span></div>
              <div><strong>Location:</strong> {viewJobSheet.location || '-'}</div>
              <div><strong>Technician:</strong> {viewJobSheet.technician || '-'}</div>
              <div><strong>Added By:</strong> {viewJobSheet.added_by || '-'}</div>
              <div><strong>Due Date:</strong> {viewJobSheet.delivery_date || '-'}</div>
              <div><strong>Created At:</strong> {viewJobSheet.created_at || '-'}</div>
            </div>
            <div className="rep-modal-footer" style={{ marginTop: '1.5rem' }}>
              <button className="rep-btn rep-btn-primary" onClick={() => setShowViewJobSheetModal(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* View Invoice Modal */}
      {showViewInvoiceModal && viewInvoice && (
        <div className="rep-modal-overlay" onClick={() => setShowViewInvoiceModal(false)}>
          <div className="rep-modal" style={{ maxWidth: '650px' }} onClick={e => e.stopPropagation()}>
            <div className="rep-modal-header">
              <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}><i className="fas fa-file-invoice-dollar" /> Repair Invoice: {viewInvoice.invoice_no}</h3>
              <button className="rep-modal-close" onClick={() => setShowViewInvoiceModal(false)}>&times;</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.85rem', fontSize: '0.88rem' }}>
              <div><strong>Invoice No:</strong> {viewInvoice.invoice_no || '-'}</div>
              <div><strong>Transaction Date:</strong> {viewInvoice.transaction_date || '-'}</div>
              <div><strong>Customer Name:</strong> {viewInvoice.name || '-'}</div>
              <div><strong>Brand:</strong> {viewInvoice.brand || '-'}</div>
              <div><strong>Device Model:</strong> {viewInvoice.device_model || '-'}</div>
              <div><strong>Serial Number:</strong> {viewInvoice.repair_serial_no || '-'}</div>
              <div><strong>Total Amount:</strong> {fc(viewInvoice.final_total)}</div>
              <div><strong>Payment Status:</strong> {viewInvoice.payment_status || '-'}</div>
              <div><strong>Repair Status:</strong> <span style={{ padding: '0.2rem 0.5rem', borderRadius: '10px', background: viewInvoice.status_color || '#e2e8f0', color: '#fff', fontSize: '0.75rem', fontWeight: 700 }}>{viewInvoice.repair_status}</span></div>
              <div><strong>Location:</strong> {viewInvoice.business_location || '-'}</div>
              <div><strong>Warranty:</strong> {viewInvoice.warranty_name || '-'}</div>
              <div><strong>Added By:</strong> {viewInvoice.added_by || '-'}</div>
            </div>
            <div className="rep-modal-footer" style={{ marginTop: '1.5rem' }}>
              <button className="rep-btn rep-btn-primary" onClick={() => setShowViewInvoiceModal(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
      {/* Quick Add Customer Modal */}
      {showCustomerModal && (
        <div className="rep-modal-overlay" onClick={() => setShowCustomerModal(false)}>
          <div className="rep-modal" onClick={e => e.stopPropagation()}>
            <div className="rep-modal-header">
              <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}><i className="fas fa-user-plus" /> Add Customer</h3>
              <button className="rep-modal-close" onClick={() => setShowCustomerModal(false)}>&times;</button>
            </div>
            <div className="rep-form-group"><label>Customer Name: <span style={{ color: '#ef4444' }}>*</span></label><input type="text" className="rep-input" placeholder="Customer Name" value={customerForm.name} onChange={e => setCustomerForm({ ...customerForm, name: e.target.value })} /></div>
            <div className="rep-form-group" style={{ marginTop: '1rem' }}><label>Mobile Number:</label><input type="text" className="rep-input" placeholder="Mobile Number" value={customerForm.mobile} onChange={e => setCustomerForm({ ...customerForm, mobile: e.target.value })} /></div>
            <div className="rep-form-group" style={{ marginTop: '1rem' }}><label>Email Address:</label><input type="email" className="rep-input" placeholder="Email Address" value={customerForm.email} onChange={e => setCustomerForm({ ...customerForm, email: e.target.value })} /></div>
            <div className="rep-modal-footer" style={{ marginTop: '1.5rem' }}>
              <button className="rep-btn" onClick={() => setShowCustomerModal(false)}>Cancel</button>
              <button className="rep-btn rep-btn-primary" onClick={handleSaveCustomer} disabled={loading}><i className="fas fa-save" /> Save Customer</button>
            </div>
          </div>
        </div>
      )}

      {/* Quick Add Device Modal */}
      {showDeviceModal && (
        <div className="rep-modal-overlay" onClick={() => setShowDeviceModal(false)}>
          <div className="rep-modal" onClick={e => e.stopPropagation()}>
            <div className="rep-modal-header">
              <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}><i className="fas fa-mobile-alt" /> Add Device</h3>
              <button className="rep-modal-close" onClick={() => setShowDeviceModal(false)}>&times;</button>
            </div>
            <div className="rep-form-group"><label>Device Name: <span style={{ color: '#ef4444' }}>*</span></label><input type="text" className="rep-input" placeholder="e.g. Mobile, Laptop, Tablet" value={deviceForm.name} onChange={e => setDeviceForm({ ...deviceForm, name: e.target.value })} /></div>
            <div className="rep-form-group" style={{ marginTop: '1rem' }}><label>Short Code:</label><input type="text" className="rep-input" placeholder="e.g. MOB" value={deviceForm.short_code} onChange={e => setDeviceForm({ ...deviceForm, short_code: e.target.value })} /></div>
            <div className="rep-modal-footer" style={{ marginTop: '1.5rem' }}>
              <button className="rep-btn" onClick={() => setShowDeviceModal(false)}>Cancel</button>
              <button className="rep-btn rep-btn-primary" onClick={handleSaveDevice} disabled={loading}><i className="fas fa-save" /> Save Device</button>
            </div>
          </div>
        </div>
      )}

      {/* Quick Add Device Model Modal */}
      {showDeviceModelModal && (
        <div className="rep-modal-overlay" onClick={() => setShowDeviceModelModal(false)}>
          <div className="rep-modal" onClick={e => e.stopPropagation()}>
            <div className="rep-modal-header">
              <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}><i className="fas fa-bolt" /> Add Device Model</h3>
              <button className="rep-modal-close" onClick={() => setShowDeviceModelModal(false)}>&times;</button>
            </div>
            <div className="rep-form-group"><label>Model Name: <span style={{ color: '#ef4444' }}>*</span></label><input type="text" className="rep-input" placeholder="e.g. iPhone 15 Pro, Galaxy S24" value={deviceModelForm.name} onChange={e => setDeviceModelForm({ ...deviceModelForm, name: e.target.value })} /></div>
            <div className="rep-form-group" style={{ marginTop: '1rem' }}><label>Brand:</label><select className="rep-select" value={deviceModelForm.brand_id} onChange={e => setDeviceModelForm({ ...deviceModelForm, brand_id: e.target.value })}><option value="">Select Brand</option>{brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}</select></div>
            <div className="rep-form-group" style={{ marginTop: '1rem' }}><label>Device:</label><select className="rep-select" value={deviceModelForm.device_id} onChange={e => setDeviceModelForm({ ...deviceModelForm, device_id: e.target.value })}><option value="">Select Device</option>{devices.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}</select></div>
            <div className="rep-modal-footer" style={{ marginTop: '1.5rem' }}>
              <button className="rep-btn" onClick={() => setShowDeviceModelModal(false)}>Cancel</button>
              <button className="rep-btn rep-btn-primary" onClick={handleSaveDeviceModel} disabled={loading}><i className="fas fa-save" /> Save Model</button>
            </div>
          </div>
        </div>
      )}

      {/* Quick Add Brand Modal */}
      {showBrandModal && (
        <div className="rep-modal-overlay" onClick={() => setShowBrandModal(false)}>
          <div className="rep-modal" onClick={e => e.stopPropagation()}>
            <div className="rep-modal-header">
              <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}><i className="fas fa-tags" /> {editBrandId ? 'Edit Brand' : 'Add Brand'}</h3>
              <button className="rep-modal-close" onClick={() => { setShowBrandModal(false); setEditBrandId(null); }}>&times;</button>
            </div>
            <div className="rep-form-group"><label>Brand name: <span style={{ color: '#ef4444' }}>*</span></label><input type="text" className="rep-input" placeholder="Brand name" value={brandForm.name} onChange={e => setBrandForm({ ...brandForm, name: e.target.value })} /></div>
            <div className="rep-form-group" style={{ marginTop: '1rem' }}><label>Short description:</label><input type="text" className="rep-input" placeholder="Short description" value={brandForm.description} onChange={e => setBrandForm({ ...brandForm, description: e.target.value })} /></div>
            <div style={{ marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}><input type="checkbox" id="use_for_repair" checked={brandForm.use_for_repair} onChange={e => setBrandForm({ ...brandForm, use_for_repair: e.target.checked })} /><label htmlFor="use_for_repair" style={{ fontWeight: 600, fontSize: '0.88rem' }}>Use for repair?</label></div>
            <div className="rep-modal-footer" style={{ marginTop: '1.5rem' }}>
              <button className="rep-btn" onClick={() => setShowBrandModal(false)}>Cancel</button>
              <button className="rep-btn rep-btn-primary" onClick={handleSaveBrand} disabled={loading}><i className="fas fa-save" /> Save Brand</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Repair;
